import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AppShell } from './components/layout/AppShell';
import { Login } from './pages/Auth/Login';
import { TwoFactorAuth } from './pages/Auth/TwoFactorAuth';
import { ForgotPassword } from './pages/Auth/ForgotPassword';
import { Dashboard } from './pages/Dashboard';
import { LeadsTable } from './pages/Leads/LeadsTable';
import { LeadDetail } from './pages/Leads/LeadDetail';
import { ClientsTable } from './pages/Clients/ClientsTable';
import { ClientDetail } from './pages/Clients/ClientDetail';
import { DealsKanban } from './pages/Deals/DealsKanban';
import { DealsTable } from './pages/Deals/DealsTable';
import { DealDetail } from './pages/Deals/DealDetail';
import { RenewalsTable } from './pages/Renewals/RenewalsTable';
import { RenewalDetail } from './pages/Renewals/RenewalDetail';
import { CommunicationHub } from './pages/Communication/CommunicationHub';
import { InboxPage } from './pages/Communication/InboxPage';
import { ReportsOverview } from './pages/Reports/ReportsOverview';
import { Organization } from './pages/Settings/Organization';
import { UsersRoles } from './pages/Settings/UsersRoles';
import { Integrations } from './pages/Settings/Integrations';
import { Templates } from './pages/Settings/Templates';
import { NamingRules } from './pages/Settings/NamingRules';
import { AuditLog } from './pages/Settings/AuditLog';
import { ApplicationsTable } from './pages/Applications/ApplicationsTable';
import { ApplicationDetail } from './pages/Applications/ApplicationDetail';
import { ApplicationDocuments } from './pages/Applications/ApplicationDocuments';
import { DocumentDetail } from './pages/Documents/DocumentDetail';
import { AuthProvider } from './context/AuthContext';
import { UserProvider } from './context/UserContext';
import { ToastProvider } from './context/ToastContext';
export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  // Function to handle login
  const handleLogin = () => {
    setIsAuthenticated(true);
  };
  // Function to handle logout
  const handleLogout = () => {
    setIsAuthenticated(false);
  };
  return <AuthProvider data-id="element-0">
      <UserProvider data-id="element-1">
        <ToastProvider data-id="element-2">
          <Router data-id="element-3">
            <Routes data-id="element-4">
              {/* Auth Routes */}
              <Route path="/login" element={<Login onLogin={handleLogin} data-id="element-6" />} data-id="element-5" />
              <Route path="/two-factor-auth" element={<TwoFactorAuth data-id="element-8" />} data-id="element-7" />
              <Route path="/forgot-password" element={<ForgotPassword data-id="element-10" />} data-id="element-9" />
              {/* Protected Routes */}
              <Route path="/*" element={isAuthenticated ? <AppShell onLogout={handleLogout} data-id="element-12">
                      <Routes data-id="element-13">
                        <Route path="/" element={<Dashboard data-id="element-15" />} data-id="element-14" />
                        <Route path="/leads" element={<LeadsTable data-id="element-17" />} data-id="element-16" />
                        <Route path="/leads/:id" element={<LeadDetail data-id="element-19" />} data-id="element-18" />
                        <Route path="/clients" element={<ClientsTable data-id="element-21" />} data-id="element-20" />
                        <Route path="/clients/:id" element={<ClientDetail data-id="element-23" />} data-id="element-22" />
                        <Route path="/deals/kanban" element={<DealsKanban data-id="element-25" />} data-id="element-24" />
                        <Route path="/deals/table" element={<DealsTable data-id="element-27" />} data-id="element-26" />
                        <Route path="/deals/:id" element={<DealDetail data-id="element-29" />} data-id="element-28" />
                        {/* Applications Routes */}
                        <Route path="/applications" element={<ApplicationsTable data-id="element-31" />} data-id="element-30" />
                        <Route path="/applications/documents" element={<ApplicationDocuments data-id="element-33" />} data-id="element-32" />
                        <Route path="/applications/:id" element={<ApplicationDetail data-id="element-35" />} data-id="element-34" />
                        <Route path="/applications/documents/:id" element={<DocumentDetail data-id="element-37" />} data-id="element-36" />
                        <Route path="/renewals" element={<RenewalsTable data-id="element-39" />} data-id="element-38" />
                        <Route path="/renewals/:id" element={<RenewalDetail data-id="element-41" />} data-id="element-40" />
                        <Route path="/communication" element={<CommunicationHub data-id="element-43" />} data-id="element-42" />
                        <Route path="/inbox" element={<InboxPage data-id="element-45" />} data-id="element-44" />
                        <Route path="/reports" element={<ReportsOverview data-id="element-47" />} data-id="element-46" />
                        <Route path="/settings/organization" element={<Organization data-id="element-49" />} data-id="element-48" />
                        <Route path="/settings/users-roles" element={<UsersRoles data-id="element-51" />} data-id="element-50" />
                        <Route path="/settings/integrations" element={<Integrations data-id="element-53" />} data-id="element-52" />
                        <Route path="/settings/templates" element={<Templates data-id="element-55" />} data-id="element-54" />
                        <Route path="/settings/naming-rules" element={<NamingRules data-id="element-57" />} data-id="element-56" />
                        <Route path="/settings/audit-log" element={<AuditLog data-id="element-59" />} data-id="element-58" />
                      </Routes>
                    </AppShell> : <Navigate to="/login" replace data-id="element-60" />} data-id="element-11" />
            </Routes>
          </Router>
        </ToastProvider>
      </UserProvider>
    </AuthProvider>;
}